import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface BackgroundWrapperProps {
  children: ReactNode
  className?: string
}

export function BackgroundWrapper({
  children,
  className,
}: BackgroundWrapperProps) {
  return (
    <div
      className={cn(
        'relative min-h-screen bg-black text-white overflow-hidden',
        className
      )}
    >
      {/* SVG Dotted Pattern */}
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full fill-neutral-400/80 [mask-image:linear-gradient(to_bottom,white,transparent)]"
      >
        <defs>
          <pattern
            id="dotted-pattern"
            width="26"
            height="26"
            patternUnits="userSpaceOnUse"
            patternContentUnits="userSpaceOnUse"
            x="0"
            y="0"
          >
            <circle id="pattern-circle" cx="0" cy="0" r="1"></circle>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#dotted-pattern)"
        ></rect>
      </svg>

      {/* Shooting Meteors */}
      <div className="absolute inset-0 z-5 overflow-hidden">
        {Array.from({ length: 8 }, (_, i) => (
          <span
            key={i}
            className="pointer-events-none absolute size-0.5 rotate-[215deg] animate-meteor rounded-full bg-slate-500 shadow-[0_0_0_1px_#ffffff10]"
            style={{
              top: `${Math.random() * -100}px`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${5 + Math.random() * 3}s`,
            }}
          >
            <div className="pointer-events-none absolute top-1/2 -z-10 h-px w-[50px] -translate-y-1/2 bg-gradient-to-r from-slate-500 to-transparent"></div>
          </span>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10">{children}</div>
    </div>
  )
}
